import { EBEPaymentMethodsName } from '../../../../contracts';

export const PAYMENT_METHODS_NAMES_TO_DISPLAY_NAMES: Record<string, string> = {
  [EBEPaymentMethodsName.blikCheckout]: 'Blik',
  [EBEPaymentMethodsName.blik]: 'Blik',
};
